import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './hsm-vs-hem/HeroSection';
import { IntroSection } from './hsm-vs-hem/IntroSection';
import { HSMSection } from './hsm-vs-hem/HSMSection';
import { HEMSection } from './hsm-vs-hem/HEMSection';
import { ComparisonSection } from './hsm-vs-hem/ComparisonSection';
import { HEMDefinedSection } from './hsm-vs-hem/HEMDefinedSection';
import { BuiltInCAMSection } from './hsm-vs-hem/BuiltInCAMSection';
import { ImportanceOfToolingSection } from './hsm-vs-hem/ImportanceOfToolingSection';
import { MikronMachinesSection } from './hsm-vs-hem/MikronMachinesSection';
import { MikronDNASection } from './hsm-vs-hem/MikronDNASection';
export function HSMvsHEMPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2967">
      <SeoBar data-id="element-2968" />
      <Header data-id="element-2969" />
      <main className="flex-grow" data-id="element-2970">
        <div className="w-full bg-gray-50 pb-20" data-id="element-2971">
          <HeroSection data-id="element-2972" />
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-2973">
            <IntroSection data-id="element-2974" />
            <HSMSection data-id="element-2975" />
            <HEMSection data-id="element-2976" />
            <ComparisonSection data-id="element-2977" />
            <HEMDefinedSection data-id="element-2978" />
            <BuiltInCAMSection data-id="element-2979" />
            <ImportanceOfToolingSection data-id="element-2980" />
            <MikronMachinesSection data-id="element-2981" />
            <MikronDNASection data-id="element-2982" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2983" />
    </div>;
}